import * as Navigation from 'constants/navigation';

interface OpenLeftDrawerAction {
  type: typeof Navigation.OPEN_LEFT_DRAWER;
}

interface CloseLeftDrawerAction {
  type: typeof Navigation.CLOSE_LEFT_DRAWER;
}

interface OpenLeftDrawerWithTabAction {
  type: typeof Navigation.OPEN_LEFT_DRAWER_WITH_TAB;
  payload: { tabId: string };
}

export function openLeftDrawer(): OpenLeftDrawerAction {
  return { type: Navigation.OPEN_LEFT_DRAWER };
}

export function closeLeftDrawer(): CloseLeftDrawerAction {
  return { type: Navigation.CLOSE_LEFT_DRAWER };
}

export function openLeftDrawerWithTab(tabId: string): OpenLeftDrawerWithTabAction {
  return {
    type: Navigation.OPEN_LEFT_DRAWER_WITH_TAB,
    payload: { tabId },
  };
}
